export const reportError = async (options) => {
    try {
        await fetch('/apps/store/bummer.mvc', {
            method: 'POST',
            body: JSON.stringify(options)
        })
    } catch (error) {
        console.error("Unable to call bummer.mvc for 404 logging:" + error);
    }
}